import { useFormik } from 'formik'
import Input from 'MediaManager/components/Form/Input'
import Textarea from 'MediaManager/components/Form/Textarea'
import {
  getRoomClassifications,
  upsertPackageRoomClassification,
  upsertRoomClassificationPackageCategories,
} from 'MediaManager/services/roomClassifications'
import React, { useCallback, useMemo } from 'react'
import Button from 'shared/components/Button'
import Select from 'shared/components/Select'
import TinyModal from 'shared/components/TinyModal'
import { useRequest } from 'shared/hooks/useRequest'

function RoomModal({ onClose = () => {}, onSuccess = () => {}, existingRooms = [], pack }) {
  const getRoomClassificationsData = useCallback(async () => {
    const { data } = await getRoomClassifications()
    return data.room_classifications
  }, [])

  const { data: roomClassifications } = useRequest(getRoomClassificationsData)

  const formik = useFormik({
    initialValues: {},
    validateOnBlur: true,
    // validationSchema,
    initialTouched: false,
    validateOnMount: true,
    onSubmit: async () => {
      try {
        await upsertRoomClassificationPackageCategories({
          room_classification_id: formik.values.room_classification_id,
          categories: formik.values.items_csv,
          package_id: pack.id,
        })
      } catch (error) {
        console.error('Partial error while adding room:', error)
      } finally {
        onSuccess()
      }
  
    },
  })

  const roomOptions = useMemo(() => {
    if (roomClassifications) {
      return roomClassifications
        .filter((r) => !existingRooms.map((r) => r.id).includes(r.id))
        .map((r) => ({
          label: r.classification_name,
          value: r.id,
        }))
    }
    return []
  }, [roomClassifications])

  const isValid = true

  return (
    <TinyModal title="Add Room to Furniture Package" className="lg:!w-[500px]">
      <form className="w-full" onSubmit={formik.handleSubmit}>
        <Select
          options={roomOptions}
          label="Room Classification *"
          onChange={(val) => formik.setFieldValue('room_classification_id', val.value)}
        />
        <Textarea
          label="Items List (CSV)"
          placeholder="Enter CSV items list"
          name="items_csv"
          wrapClassName='mt-[16px]'
          onChange={formik.handleChange}
        />
        <div
          className={`flex justify-end items-center  w-full mt-[16px] ${
            formik.isSubmitting ? 'pointer-events-none  opacity-50' : ''
          }`}
        >
          <Button size="small" rounded variant="secondary" onClick={onClose}>
            Cancel
          </Button>
          <Button
            size="small"
            loading={formik.isSubmitting}
            disabled={!isValid}
            rounded
            className="ml-[16px]"
            type="submit"
          >
            Add
          </Button>
        </div>
      </form>
    </TinyModal>
  )
}

export default RoomModal
